// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z26pS","importantInfo":"styles_importantInfo__3Uz0B"};